var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuOrderinstractionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33398 1.99967C1.33398 1.63148 1.63246 1.33301 2.00065 1.33301H6.66732C7.03551 1.33301 7.33398 1.63148 7.33398 1.99967V6.66634C7.33398 7.03453 7.03551 7.33301 6.66732 7.33301H2.00065C1.63246 7.33301 1.33398 7.03453 1.33398 6.66634V1.99967ZM2.66732 2.66634V5.99967H6.00065V2.66634H2.66732Z",
    fill: "#7E716D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66602 1.99967C8.66602 1.63148 8.96449 1.33301 9.33268 1.33301H13.9993C14.3675 1.33301 14.666 1.63148 14.666 1.99967V6.66634C14.666 7.03453 14.3675 7.33301 13.9993 7.33301H9.33268C8.96449 7.33301 8.66602 7.03453 8.66602 6.66634V1.99967ZM9.99935 2.66634V5.99967H13.3327V2.66634H9.99935Z",
    fill: "#7E716D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66602 9.33366C8.66602 8.96547 8.96449 8.66699 9.33268 8.66699H13.9993C14.3675 8.66699 14.666 8.96547 14.666 9.33366V14.0003C14.666 14.3685 14.3675 14.667 13.9993 14.667H9.33268C8.96449 14.667 8.66602 14.3685 8.66602 14.0003V9.33366ZM9.99935 10.0003V13.3337H13.3327V10.0003H9.99935Z",
    fill: "#7E716D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33398 9.33366C1.33398 8.96547 1.63246 8.66699 2.00065 8.66699H6.66732C7.03551 8.66699 7.33398 8.96547 7.33398 9.33366V14.0003C7.33398 14.3685 7.03551 14.667 6.66732 14.667H2.00065C1.63246 14.667 1.33398 14.3685 1.33398 14.0003V9.33366ZM2.66732 10.0003V13.3337H6.00065V10.0003H2.66732Z",
    fill: "#7E716D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOrderinstractionIcon);
export default __webpack_public_path__ + "static/media/menu-orderinstraction-icon.fb7286a632a0a1d65bcbb4cca62fb226.svg";
export { ForwardRef as ReactComponent };